Drupal.behaviors.pilotAppLoaderV1 = {
  attach: function (context, settings) {
    const self = this;
    const container = document.getElementById('app_loader_v1');
    const {
      loadOnHash,
      hash,
      dir,
      file,
      useEnv,
      useCdnOrigin
    } = container?.dataset ?? {};
    const loadingParams = { env: settings?.globals_variables?.pilot_env, dir, file, useEnv, useCdnOrigin };
    if (loadOnHash === '1') {
      window.addEventListener('hashchange', function (e) {
        if (location.hash === hash) {
          self.load(loadingParams);
        }
      });
      if (location.hash === hash) {
        self.load(loadingParams);
      }
    } else {
      self.load(loadingParams);
    }
  },
  load: function (loadingParams) {
    const {
      env,
      dir,
      file,
      useEnv,
      useCdnOrigin
    } = loadingParams;
    if (!dir) {
      console.warn('Cancel loading: No directory specified');
      return;
    }
    if (!file) {
      console.warn('Cancel loading: No file specified');
      return;
    }
    if (useEnv === '1' && !env) {
      console.warn('Cancel loading: Env flag used but env is not defined');
      return;
    }
    const scriptSrc = useEnv === '1' ? `${dir}/${env}/${file}` : `${dir}/${file}`;
    const script = document.createElement('script');
    script.src = useCdnOrigin ? `https://sdcdn.io/${scriptSrc}` : scriptSrc;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.onerror = function () {
      console.warn('Script load onerror at: ', scriptSrc);
    };
  }
};
